module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/razor-1f2eab0546d23e9a5882e48b37b3fe69.svg";